/**
 * Ключ метки «Ждёт отправки» над блоком урока (техдолг 386, промпт 12, 18.10.2026).
 *
 * Блок записи голоса подписан языком урока (правило `blockRenderers.(audio|record)…` → en в `fixedLanguageKeys.ts`),
 * а общая метка `blockView.queued` шла языком интерфейса: под «Record again», «Sent» стояло «Ждёт отправки».
 * У записи — свой ключ под тем же правилом; у остальных блоков (эссе, пункты) метка прежняя — языком интерфейса.
 */
export function queuedLabelKey(blockType: string): string {
  return blockType === 'audio_record' ? 'blockRenderers.recordQueued' : 'blockView.queued';
}
